import { FreightType } from "../../model/customer.model";

export function applyTaxAccordingFreight(
  freightType: FreightType,
  unitPrice: number,
  freightUnitPrice: number
): number {
  // Se o preço unitário for zero, o resultado é zero (não soma frete)
  if (unitPrice === 0) return 0;

  // CIF: preço final unitário inclui frete
  // FOB: preço final unitário NÃO inclui frete (frete é tratado fora)
  if (freightType === "CIF") return unitPrice + freightUnitPrice;
  return unitPrice;
}
